import {
  createListDataFailed,
  createListDataInProcess,
  createListDataSuccess,
} from '../utils/DataAction';
import { cacheApi } from '../utils/api';

export const getAll = () => {
  return (dispatch) => {
    dispatch(createListDataInProcess('CACHE')());
    return cacheApi
      .get()
      .then((response) => {
        dispatch(createListDataSuccess('CACHE')(response.data));
        dispatch(createListDataSuccess('MONEDA')(response.data.moneda));
        dispatch(
          createListDataSuccess('MULTIPLICADOR')(response.data.multiplicador)
        );

        dispatch(
          createListDataSuccess('PROPIETARIO')(response.data.propietarios)
        );
        dispatch(createListDataSuccess('PROVEEDOR')(response.data.proveedores));
        dispatch(createListDataSuccess('CULTIVO')(response.data.cultivos));
        dispatch(
          createListDataSuccess('ESTABLECIMIENTO')(
            response.data.establecimientos
          )
        );
        dispatch(createListDataSuccess('INSUMO')(response.data.insumos));
        dispatch(createListDataSuccess('LABOR')(response.data.labores));
        dispatch(createListDataSuccess('INVERSOR')(response.data.inversores));
        dispatch(
          createListDataSuccess('ORDEN_TRABAJO_ESTADO')(
            response.data.ordenTrabajoEstados
          )
        );
        dispatch(
          createListDataSuccess('CONTRATO_CUOTA_ESTADO')(
            response.data.contratoCuotaEstados
          )
        );
        dispatch(
          createListDataSuccess('FORMA_PAGO_CONTRATO')(
            response.data.formaPagoContrato
          )
        );
        dispatch(
          createListDataSuccess('CONDICION_IVA')(response.data.condicionIva)
        );
        dispatch(
          createListDataSuccess('CONFIGURACION')(response.data.configuracion)
        );
        dispatch(
          createListDataSuccess('PROVEEDOR_TIPO')(response.data.proveedorTipo)
        );
        dispatch(createListDataSuccess('GASTO_TIPO')(response.data.gastoTipo));
        dispatch(
          createListDataSuccess('INSUMO_TIPO')(response.data.insumoTipo)
        );
        dispatch(createListDataSuccess('DESTINO')(response.data.destino));
      })
      .catch((error) => {
        dispatch(createListDataFailed('CACHE')(error));
      });
  };
};
